import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 12L19 12M14 17L19 12L14 7" vectorEffect="non-scaling-stroke" />
	</SVG>
);
